// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__vIwb_","wrapper":"Section_wrapper__oUdxY","fade_in":"Section_fade_in__An52Q"};